var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99935 3.93366C8.77268 3.93366 9.39935 4.56033 9.39935 5.33366C9.39935 6.10699 8.77268 6.73366 7.99935 6.73366C7.22602 6.73366 6.59935 6.10699 6.59935 5.33366C6.59935 4.56033 7.22602 3.93366 7.99935 3.93366ZM7.99935 9.93366C9.97935 9.93366 12.066 10.907 12.066 11.3337V12.067H3.93268V11.3337C3.93268 10.907 6.01935 9.93366 7.99935 9.93366ZM7.99935 2.66699C6.52602 2.66699 5.33268 3.86033 5.33268 5.33366C5.33268 6.80699 6.52602 8.00033 7.99935 8.00033C9.47268 8.00033 10.666 6.80699 10.666 5.33366C10.666 3.86033 9.47268 2.66699 7.99935 2.66699ZM7.99935 8.66699C6.21935 8.66699 2.66602 9.56033 2.66602 11.3337V13.3337H13.3327V11.3337C13.3327 9.56033 9.77935 8.66699 7.99935 8.66699Z",
    fill: "#212121"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.70e20fff6596e93b02643a6f8577a309.svg";
export { ForwardRef as ReactComponent };